// Должен соответствовать projectName
/* istanbul ignore next */
export const UNIQUE_CONFIG_KEY = 'info-agency-rating-frontend';
